"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const StyledDialog = exports.StyledDialog = (0, _mui.styled)(_components.Dialog, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['zIndex'])
})(({
  zIndex
}) => ({
  zIndex
}));
